var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-body"},[_c('div',{staticClass:"ani"}),_vm._v(" "+_vm._s(_vm.text)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }